<template>
 <div class="ui centered grid">
     <div class="three wide column"></div>
    <div class="ten wide column">
        <div class="ui center aligned container">
          <TheSearchForm v-bind:advanced="accordion_advanced" @query="search"></TheSearchForm>
        </div>
    </div>
    <div class="three wide column"></div>
    <div>
      <TheAdvancedSearch v-bind:query_props="query" v-bind:margin="true"></TheAdvancedSearch>
    </div>
</div>
</template>

<script>
 
  import TheAdvancedSearch from '../components/TheAdvancedSearch.vue'
  import TheSearchForm from '../components/TheSearchForm.vue'
  export default {
    name: 'search',
    components: {
      TheAdvancedSearch,
      TheSearchForm,
    },
    data() {
      return {
        accordion_advanced: false,
        current_query: null,
        query: null
      }
    },

    methods: {
      search: function(query) {
        query.activeTab = "0";
        query.page = "1";
        query.tabbed = "true";

        if (JSON.stringify(query) != JSON.stringify(this.current_query)) {
        //  this.inventories = [];
        //  this.current_query = query;
          this.$router.push({ name: 'advancedsearch', query: query });
        }
      },

      setAccordtion: function() {
        if (Object.keys(this.$route.query).length == 1 && this.$route.query.hasOwnProperty('search')) {
          this.accordion_advanced = false;
        }
        else {
          this.accordion_advanced = true;
        }
      }
    },

    mounted() {
      this.query = this.$route.query;
      this.setAccordtion();
    },

    watch: {
      $route(to, from) {
        this.query = this.$route.query;
      },
    }
  }
</script>

<style>
  .hidden {
    display: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/router/advancedsearch.vue